// Unit conversion for AFF speed and altitude (#810).
//
// All three reporting providers — Latitude, SkyTrac and SpiderTracks — publish
// speed in metres per second and altitude in metres above sea level. That was
// established by comparing reported speed against ground speed derived from
// consecutive positions, and by comparing reported altitude against known
// ground elevations at Yellowknife, Fort Smith and Hay River.
//
// The Aviation group asked for the display to show knots and feet above sea
// level, so conversion happens on presentation only. Stored values stay in
// metres per second and metres, which keeps the database the single unit of
// record and avoids a migration.
//
// Height above ground level is deliberately not offered: Selkirk transmits
// altitude above sea level only, and AGL cannot be derived from it.

export const MS_TO_KNOTS = 1.94384;
export const METRES_TO_FEET = 3.28084;

/**
 * A missing value stays missing. An aircraft with no reported speed is not an
 * aircraft travelling at zero knots, and collapsing the two would present a
 * confident number where there is no measurement.
 */
const convert = (value: number | null | undefined, factor: number): number | null =>
  value === null || value === undefined ? null : Math.round(value * factor);

/** Metres per second as stored, to whole knots for display. */
export const metresPerSecondToKnots = (value: number | null | undefined): number | null =>
  convert(value, MS_TO_KNOTS);

/** Metres above sea level as stored, to whole feet above sea level for display. */
export const metresToFeet = (value: number | null | undefined): number | null =>
  convert(value, METRES_TO_FEET);
